// 表格的配置
const tableConfig = {
  title: '员工分析',
  icon: {
    show: false,
    message: ''
  },
  name: 'videos',
  component: null,
  showButton: true,
  mode: 'table',
  list: {
    type: 'Table', // or Image
    // 是否为多级表头
    moreColumns: true,
    columns: [
      {
        prop: 'name',
        label: '姓名',
        minWidth: '140',
        fixed: true
      },
      {
        prop: 'department',
        label: '部门',
        minWidth: '140'
      },
      {
        prop: 'mission',
        label: '学习任务',
        children: [
          {
            prop: 'completeCount',
            label: '完成数',
            sortable: 'custom',
            labelClassName: 'mission.completeCount',
            width: '95'
          },
          {
            prop: 'inCompleteCount',
            label: '未完成数',
            sortable: 'custom',
            labelClassName: 'mission.inCompleteCount',
            width: '110'
          },
          {
            prop: 'completeRate',
            label: '完成率',
            sortable: 'custom',
            labelClassName: 'mission.completeRate',
            width: '95'
          },
          {
            prop: 'durationShow',
            label: '课程学习时长',
            sortable: 'custom',
            labelClassName: 'mission.durationShow',
            width: '140'
          }
        ]
      },
      {
        prop: 'exam',
        label: '考试',
        children: [
          {
            prop: 'referenceCount',
            label: '参考数',
            sortable: 'custom',
            labelClassName: 'exam.referenceCount',
            width: '95'
          },
          {
            prop: 'completeCount',
            label: '通过数',
            sortable: 'custom',
            labelClassName: 'exam.completeCount',
            width: '95'
          },
          {
            prop: 'inCompleteCount',
            label: '未通过数',
            sortable: 'custom',
            labelClassName: 'exam.inCompleteCount',
            width: '110'
          },
          {
            prop: 'completeRate',
            label: '通过率',
            sortable: 'custom',
            labelClassName: 'exam.completeRate',
            width: '95'
          },
          {
            prop: 'average',
            label: '平均分',
            sortable: 'custom',
            labelClassName: 'exam.average',
            width: '95'
          }
        ]
      },
      {
        prop: 'course',
        label: '课程',
        children: [
          {
            prop: 'completeCount',
            label: '已学习数',
            sortable: 'custom',
            labelClassName: 'course.completeCount',
            width: '110'
          },
          {
            prop: 'inCompleteCount',
            label: '未学习数',
            sortable: 'custom',
            labelClassName: 'course.inCompleteCount',
            width: '110'
          },
          {
            prop: 'durationShow',
            label: '累积学习时长',
            sortable: 'custom',
            labelClassName: 'course.durationShow',
            width: '140'
          }
        ]
      }
    ]
  },

  params: {
    type: 'ordinaryVideo'
  },
  limit: 3
}

export default tableConfig
